export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const STATUS_COLORS = {
  draft: 'bg-zinc-100 text-zinc-600',
  active: 'bg-emerald-100 text-emerald-800',
  paused: 'bg-amber-100 text-amber-800',
  stopped: 'bg-red-100 text-red-700',
  completed: 'bg-blue-100 text-blue-800',
};

export const DAY_LABELS = ['Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag', 'Zondag'];

export const REVIEW_STATUS_STYLES = {
  nieuw: { bg: 'bg-zinc-100 text-zinc-700', label: 'Nieuw' },
  wacht_op_goedkeuring: { bg: 'bg-amber-100 text-amber-800', label: 'Wacht op goedkeuring' },
  goedgekeurd: { bg: 'bg-emerald-100 text-emerald-800', label: 'Goedgekeurd' },
  afgewezen: { bg: 'bg-red-100 text-red-700', label: 'Afgewezen' },
  verzonden: { bg: 'bg-blue-100 text-blue-800', label: 'Verzonden' },
};

export const CATEGORY_STYLES = {
  delivery_failure: { bg: 'bg-red-50 text-red-700 border-red-200', label: 'Delivery Failure', icon: '!' },
  out_of_office: { bg: 'bg-purple-50 text-purple-700 border-purple-200', label: 'Afwezig (OOO)', icon: 'O' },
  unsubscribe: { bg: 'bg-orange-50 text-orange-700 border-orange-200', label: 'Afmelding', icon: '-' },
  question: { bg: 'bg-cyan-50 text-cyan-700 border-cyan-200', label: 'Vraag', icon: '?' },
  quote_request: { bg: 'bg-emerald-50 text-emerald-700 border-emerald-200', label: 'Offerte', icon: '$' },
  order: { bg: 'bg-teal-50 text-teal-700 border-teal-200', label: 'Bestelling', icon: '#' },
  interest: { bg: 'bg-blue-50 text-blue-700 border-blue-200', label: 'Interesse', icon: '+' },
  spam_irrelevant: { bg: 'bg-zinc-50 text-zinc-400 border-zinc-200', label: 'Spam', icon: 'x' },
  other: { bg: 'bg-zinc-50 text-zinc-600 border-zinc-200', label: 'Overig', icon: '~' },
};

export const URGENCY_COLORS = {
  high: 'text-red-600 font-semibold',
  medium: 'text-amber-600',
  low: 'text-zinc-500',
};

export const LANGUAGES = [
  { code: 'nl', name: 'Nederlands' }, { code: 'en', name: 'English' },
  { code: 'de', name: 'Deutsch' }, { code: 'fr', name: 'Francais' },
  { code: 'es', name: 'Espanol' }, { code: 'it', name: 'Italiano' },
  { code: 'pl', name: 'Polski' }, { code: 'pt', name: 'Portugues' },
];

export const SEQUENCE_STEPS = [
  { step: 1, name: 'Introductie', key: 'introductie', goal: 'Contact leggen, juiste persoon vinden', delay: 0 },
  { step: 2, name: 'Educatie', key: 'educatie', goal: 'Inzichten delen over zwembadveiligheid', delay: 3 },
  { step: 3, name: 'Oplossing', key: 'oplossing', goal: 'PoolFIX oplossing introduceren', delay: 7 },
  { step: 4, name: 'Social Proof', key: 'social_proof', goal: 'Vertrouwen met klantcase', delay: 12 },
  { step: 5, name: 'Call-to-Action', key: 'call_to_action', goal: 'Concrete actie uitlokken', delay: 18 },
  { step: 6, name: 'Laatste Reminder', key: 'laatste_reminder', goal: 'Vriendelijke afsluiting', delay: 25 },
];
